<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/home"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h4><u>Διασύνδεση Τρίτων Εφαρμογών</u></h4>
        </div>
      </div>

      <div class="col-md-1" style>
        <DxLoadIndicator id="image-indicator" :height="40" :width="40" :visible="loadIndicatorVisible" />
      </div>
    </div>
    <div class="row">
      <div class="grid-pad">
        <DxDataGrid @initialized="saveGridInstance" 
          :data-source="authApps" 
          :allow-column-reordering="true"
          :allow-column-resizing="true" 
          :column-auto-width="true" 
          :show-borders="true" key-expr="Id"
          @row-inserting="onRowInserting" 
          @row-updating="onRowUpdating" 
          @init-new-row="onInitNewRow"
          :show-row-lines="true" 
          :row-alternation-enabled="true" 
          @editor-preparing="onEditorPreparing"
          @row-removing="onRowRemoving">
          
          <DxPaging :page-size="20" />
          <DxEditing :allow-updating="true" :allow-adding="true" :allow-deleting="true" mode="row" :use-icons="true" />
          <DxHeaderFilter :visible="true" />
          <DxFilterRow :visible="true" />
          <DxSearchPanel :visible="true" />

          <!-- <DxColumn  caption="Κωδικός" data-field="Id" data-type="integer" :visible="false">                    
                </DxColumn> -->
          <DxColumn caption="Φορέας" data-field="OrganizationId" data-type="int32" alignment="left" width="150px"
            :visible="true" :allow-updating="false">
            <DxLookup :data-source="organizations" value-expr="Id" display-expr="Description" />
          </DxColumn>

          <DxColumn caption="ClientGuid" data-field="ClientGuid" data-type="string" alignment="left" width="280px">
          </DxColumn>

          <DxColumn caption="ClientSecret" data-field="ClientSecret" data-type="string" alignment="left" width="230px">
          </DxColumn>

          <DxColumn caption="Domain" data-field="Domain" data-type="string" width="230px">
          </DxColumn>

          <DxColumn caption="Ενεργή" data-field="IsActive" data-type="boolean" width="100px" alignment="center">
          </DxColumn>

          <DxColumn type="buttons" :width="100">
            <DxButton name="edit" />
            <DxButton name="delete" />
            <DxButton :hint="'Ανανέωση'" icon="refresh" :on-click="refresh" :visible="true" />
          </DxColumn>
        </DxDataGrid>
      </div>
    </div>
    <DxPopup :visible="isRefreshValuesPopupVisible" :drag-enabled="false" :close-on-outside-click="true"
      :show-title="true" :show-close-button="true" :width="500" :height="180" title="Ανανέωση Τιμών">
      <div class="row">
        Είστε σίγουροι ότι θέλετε να ανανεώσετε τις τιμές για τα ClientGuid και
        ClientSecret;
      </div>

      <div class="row" style="padding-top: 20px">
        <DxButton2 class="pull-right" text="Ναι" type="success" :width="120" styling-mode="contained"
          @click="onApprove" />
        <DxButton2 text="Όχι" type="danger" :width="120" styling-mode="contained" :on-click="onClosePopup" />
      </div>
    </DxPopup>
  </div>
</template>

<script>
import router from "../../router";
import mainService from "../../services/mainService";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxEditing,
  DxPaging,
  DxLookup,
  DxFilterRow,
  DxSearchPanel,
  DxButton,
} from "devextreme-vue/data-grid";

import { DxButton as DxButton2 } from "devextreme-vue/button";
import notify from "devextreme/ui/notify";
import BackButton from "../../components/shared/backButton";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";
import { DxPopup } from "devextreme-vue/popup";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxPaging,
    DxLookup,
    DxFilterRow,
    DxSearchPanel,
    BackButton,
    DxLoadIndicator,
    DxButton,
    DxPopup,
    DxButton2,
  },
  data() {
    return {
      authApps: [],
      organizations: [],
      dataGridInstance: null,
      loadIndicatorVisible: false,
      isRefreshValuesPopupVisible: false,
      selectedExternalConnectionId: 0,
    };
  },
  async mounted() {
    this.checkUserPermissions();
    this.getOrganizations();
    this.getAuthApps();
  },
  computed: {
    organizationId() {
      return this.$store.getters.getSelectedOrganizationId;
    },
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
  },
  watch: {
    organizationId: async function (newValue, oldValue) {
      await this.getOrganizations();
      await this.getAuthApps();
    },
  },
  methods: {
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },

    refresh(e) {
      
      this.selectedExternalConnectionId = e.row.data.Id;
      this.isRefreshValuesPopupVisible = true;
    },

    checkUserPermissions(){
      if(!this.isSuperAdmin){
        this.$router.push('/home');
      }
    },

    async getAuthApps() {
      this.loadIndicatorVisible = true;
      this.authApps = [];

      try {
        const res = await mainService.get(
          `/ExternalConnections/GetExternalConnectionsByOrganization?organizationId=${this.organizationId}`
        );
        if (res.status != 200) {
          notify(
            "Υπήρξε πρόβλημα κατά την ανάσυρση των διασυνδεδεμένων εφαρμογών.",
            "error",
            1000
          );
        } else {
          this.authApps = res.data;
          this.loadIndicatorVisible = false;
        }
      } catch (error) {
        notify(
          "Υπήρξε πρόβλημα κατά την ανάσυρση των διασυνδεδεμένων εφαρμογών",
          "error",
          1000
        );
      }

      return;
    },

    async getOrganizations() {
      this.organizations = [];
      const res = await mainService.get(`Organizations/GetOrganizations`);
      this.organizations = res.data;
    },
    onInitNewRow(e) {
      e.promise = this.getNewData().then((data) => {
        e.data.IsActive = true;
        e.data.OrganizationId = this.organizationId;

        e.data.ClientGuid = data.data.ClientGuid;
        e.data.ClientSecret = data.data.ClientSecret;
      });
    },

    onApprove(e) {
      try {
        var res = mainService.post(
          `/ExternalConnections/RefreshValues?id=${this.selectedExternalConnectionId}`
        );
        notify(
          "Η ενημέρωση των ClientGuid και ClientSecret έγινε επιτυχώς",
          "success",
          2000
        );
        this.getAuthApps();
      } catch {
        notify("Υπήρξε κάποιο πρόβλημα. Η ενημέρωση απέτυχε. ", "error", 2000);
        this.getAuthApps();
      }
      this.isRefreshValuesPopupVisible = false;
    },

    onClosePopup() {
      this.isRefreshValuesPopupVisible = false;
    },

    async getNewData() {
      var res = await mainService.get(
        `/ExternalConnections/GetNewExternalConnectionData`
      );
      return res;
    },

    async onRowInserting(e) {
      var authApp = e.data;
      try {
        const res = await mainService.post(
          "/ExternalConnections/AddExternalConnection",
          authApp
        );
        notify("Η εγγραφή εισήχθη επιτυχώς", "success", 2000);
        this.getAuthApps();
      } catch {
        e.cancel = true;
        notify(
          "Υπήρξε πρόβλημα! Ελέγξτε ότι το Domain δεν χρησιμοποιείται σε άλλη εγγραφή.",
          "error",
          5000
        );
        this.getAuthApps();
      }
    },

    onEditorPreparing(e) {
      if (e.parentType == "dataRow") {
        if (e.dataField == "OrganizationId") e.editorOptions.readOnly = true;
        if (e.dataField == "ClientGuid") e.editorOptions.readOnly = true;
        if (e.dataField == "ClientSecret") e.editorOptions.readOnly = true;
      }
    },

    async onRowUpdating(e) {
      var authApp = Object.assign(e.oldData, e.newData);
      authApp.Id = e.key;
      authApp.OrganizationId = this.organizationId;

      try {
        const res = await mainService.post(
          "/ExternalConnections/UpdateExternalConnection",
          authApp
        );
        notify("Η αποθήκευση πέτυχε", "success", 2000);
      } catch (error) {
        e.cancel = true;
        await this.getOrganizations();
        await this.getAuthApps();
        notify(
          "Υπήρξε πρόβλημα! Ελέγξτε ότι το Domain δεν χρησιμοποιείται σε άλλη εγγραφή.",
          "error",
          5000
        );
      }
      return;
    },

    async onRowRemoving(e) {
      const res = await mainService.delete(
        `/ExternalConnections/DeleteExternalConnection?id=${e.data.Id}`
      );
      if (res.data == false) {
        e.cancel = true;
        notify("Αποτυχία διαγραφής.", "error", 5000);
      }
    },
  },
};
</script>